export default {
  title: 'Rekapitulace Vaší žádosti',
  birthNumber: {
    label: 'Rodné číslo:',
  },
  identityCard: {
    label: 'Číslo OP:',
  },

  loanAmount: 'Výše úvěru',
  czkPerMonth: 'Kč / měs.',
};
